import React, { useState, useEffect } from "react";

import BellTopBar from "../../../../Components/Bars/BellTopBar";

import { TableTopBar } from "../../../../Components/FinalTable";

import TFilter from "./Components/TableComponent/TFilter";

import usePouchPagination from "../../../../Hooks/usePouchPagination";

import useFuzzySearch from "../../../../Hooks/useFuzzySearch";

import { useNavigate } from "react-router-dom";

import AllContext from "./AllContext";

import TableAll from "./Components/TableComponent/Table";

const AllPatients = ({ showLive }) => {
  const navigate = useNavigate();

  const [openFilter, setOpenFilter] = useState(false);

  const [limit, setLimit] = useState(5);
  const [data, setData] = useState([]);
  const [showPagination, setShowPagination] = useState(true);

  const [tableIsLoading, setTableIsLoading] = useState(false);
  const [isFiltered, setIsFiltered] = useState(false);

  const [searchInput, setSearchInput] = useState("");

  const db_name = "hospital_queue";

  const initialIndex = ["created_at"];

  const initialSort = [{ created_at: "desc" }];

  const initialSelector = {
    created_at: { $gte: null },
  };

  const searchOptions = {
    keys: ["first_name"],
    minMatchCharLength: 3,
    threshold: 0.5,
  };

  const {
    hasNextPage,
    hasPrevPage,
    handleNext,
    handlePrev,
    handleHeaderQuery,
    handleFilterQuery,
    resetQuery,
    page,
    total,
  } = usePouchPagination({
    db_name,
    limit,
    initialSort,
    initialIndex,
    initialSelector,
    setData,
    setTableIsLoading,
  });

  useFuzzySearch({
    db_name,
    input: searchInput,
    options: searchOptions,
    limit,
    setShowPagination,
    setIsFiltered,
    setTableIsLoading,
    setData,
  });

  async function handleClearFilters() {
    await resetQuery();
    setIsFiltered(false);
    setSearchInput("");
  }

  async function handleLiveStream() {
    await resetQuery();
  }

  return (
    <AllContext.Provider
      value={{
        showLive,
        limit,
        setLimit,
        data: data,
        page,
        hasNextPage,
        hasPrevPage,
        handleNext,
        handlePrev,
        handleHeaderQuery,
        handleFilterQuery,
        isFiltered,
        handleClearFilters,
        total,
        setIsFiltered,
        showPagination,
        resetQuery,
      }}
    >
      <div className="w-full h-screen  bg-ghost_white">
        <div className="w-full bg-ghost_white">
          <BellTopBar label="Hospital Queue" />
        </div>
        <div className="w-full px-7 pb-8">
          <TableTopBar
            FilterClick={() => setOpenFilter(true)}
            mt={2}
            mb={2}
            addLabel="Add"
            changes={0}
            showAdd={false}
            AddClick={() => navigate("add")}
            handleLiveStream={handleLiveStream}
            isFiltered={isFiltered}
            handleClearFilters={handleClearFilters}
            tableIsLoading={tableIsLoading}
            showReport={false}
            showFilter={false}
            searchInput={searchInput}
            setSearchInput={setSearchInput}
            showSearch={false}
          />
          <TableAll />
          <TFilter showFilter={openFilter} setShowFilter={setOpenFilter} />
        </div>
      </div>
    </AllContext.Provider>
  );
};
export default AllPatients;
